import { motion } from "framer-motion";
import podImage from "../assets/pod-design.png";

// Version 3: Minimal, elegant with larger pod visual
const PartnerAd3 = () => {
  return (
    <div className="h-screen bg-background flex flex-col items-center justify-center px-6 py-8 overflow-hidden relative">
      {/* Subtle background glow */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-[0.03]"
        style={{
          background: "radial-gradient(circle at 50% 50%, hsl(var(--foreground)) 0%, transparent 50%)"
        }}
      />

      {/* Single centered content block */}
      <div className="flex flex-col items-center">
        {/* Large pod image - hero visual */}
        <motion.img
          src={podImage}
          alt="qwip soundproof pod"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.1, type: "spring", stiffness: 80 }}
          className="w-44 drop-shadow-2xl mb-6"
        />

        {/* Simple question */}
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.5 }}
          className="text-foreground text-center text-xl font-medium leading-relaxed mb-6"
        >
          Got 1m² of spare space
          <br />
          in London?
        </motion.p>

        {/* Value prop - stacked */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.75 }}
          className="text-center mb-6"
        >
          <p className="text-muted-foreground text-base">Host a qwip pod</p>
          <p className="font-funnel text-5xl font-bold text-foreground mt-2">£3k/month</p>
        </motion.div>

        {/* Dual trust badges */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35, delay: 1 }}
          className="flex gap-3"
        >
          <span className="bg-foreground/10 text-foreground text-xs font-medium px-3 py-1.5 rounded-full">
            Zero cost
          </span>
          <span className="bg-foreground/10 text-foreground text-xs font-medium px-3 py-1.5 rounded-full">
            We install
          </span>
        </motion.div>
      </div>

      {/* Bottom: Logo and tagline - fixed position */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 1.2 }}
        className="absolute bottom-8 text-center"
      >
        <span className="font-funnel text-2xl font-bold text-foreground">qwip</span>
        <p className="font-cormorant italic text-foreground/80 text-lg font-semibold mt-1">
          bookable, quiet pods - wherever you go.
        </p>
      </motion.div>
    </div>
  );
};

export default PartnerAd3;
